type env = "localhost" | "stage" | "prod";

type TENVIRONMENT_VAR = {
  API_URL: string;
  API_KEY: string;
  COOKIE_DOMAIN: string;
  MAXCORE_DOMAIN_V1: string;
  COOKIE_TOKEN: string;
  COOKIE_DATA: string;
  NODE_ENV: env;
  VERSION: string | undefined;
  MOCK_SERVER: string;
};

const ENVIRONMENT_VAR: TENVIRONMENT_VAR = {
  API_URL: import.meta.env.VITE_API_URL as string,
  API_KEY: `${import.meta.env.VITE_API_KEY}$2`,
  COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN as string,
  MAXCORE_DOMAIN_V1: import.meta.env.VITE_MAXCORE_DOMAIN_V1 as string,
  // MAXCORE_DOMAIN_V2: import.meta.env.VITE_MAXCORE_DOMAIN_V2 as string,
  COOKIE_TOKEN: import.meta.env.VITE_COOKIE_TOKEN as string,
  COOKIE_DATA: import.meta.env.VITE_COOKIE_DATA as string,
  NODE_ENV: import.meta.env.VITE_ENV as env,
  VERSION: import.meta.env.APP_VERSION,
  MOCK_SERVER: "https://dd49e24f-eb06-4894-b80b-fbe3eae78bb6.mock.pstmn.io"
};

export default ENVIRONMENT_VAR;
